import React from 'react';
import { RentalscapeTitle } from '@/login/components/login-form-styles';
import {
  FullPagePlaceholderBackground,
  LogoWrapper,
  StyledRentalscapeLogo,
} from '@/placeholders/placeholder-styles';

export const BackgroundWithLogo = ({ children }) => (
  <FullPagePlaceholderBackground>
    <LogoWrapper>
      <StyledRentalscapeLogo />
      <RentalscapeTitle />
    </LogoWrapper>
    {children}
  </FullPagePlaceholderBackground>
);
